import { render, staticRenderFns } from "./LeadsCRM.vue?vue&type=template&id=6554bbf2&scoped=true"
import script from "./LeadsCRM.vue?vue&type=script&lang=js"
export * from "./LeadsCRM.vue?vue&type=script&lang=js"
import style0 from "./LeadsCRM.vue?vue&type=style&index=0&id=6554bbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554bbf2",
  null
  
)

export default component.exports